var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkedHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.05493V2H7V0H11V2H10V3.05493C11.7355 3.24678 13.3223 3.9321 14.6169 4.96747L16.2913 3.28566L17.7087 4.69677L16.0313 6.38152C17.2633 7.92132 18 9.87462 18 12C18 16.9706 13.9706 21 9 21C4.02944 21 0 16.9706 0 12C0 7.36745 3.50005 3.55237 8 3.05493ZM9 19C12.866 19 16 15.866 16 12C16 8.13401 12.866 5 9 5C5.13401 5 2 8.13401 2 12C2 15.866 5.13401 19 9 19ZM10 13V7H8V13H10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkedHours);
export default __webpack_public_path__ + "static/media/WorkedHours.7e424bb5.svg";
export { ForwardRef as ReactComponent };